import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useAnalytics } from 'hooks';
import { MediaPlayer, useWrapperContext } from 'msp-components';
import ButtonShare from 'components/ButtonShare';
import Error404 from 'components/Error404';

const StyledContainer = styled.div`
  background-color: #fff;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  position: relative;
  width: 100%;
`;

const MediaTitle = ({ routeProps, type, source, versions, metadata }) => {
  const [isFullscreen, setIsFullscreen] = useState(false);

  const sourceType = type === 'video' ? source : 'htmlAudio';
  const playerSource = source === 'file' ? versions[0].url : metadata.sourceUrl;

  const { renderControls } = useWrapperContext();
  const controls = renderControls(null);
  const portalEl = controls && controls.containerInfo;

  // analytics event tracking
  const { trackMediaPlay, trackMediaProgress } = useAnalytics();

  if (!routeProps.match.isExact) return <Error404 />;

  return (
    <StyledContainer key={source}>
      {controls}
      {controls && (
        <MediaPlayer
          afterControls={type === 'video' && !isFullscreen && <ButtonShare />}
          allowFullscreen={type === 'video'}
          sourceType={sourceType}
          source={playerSource}
          controlsPortalEl={isFullscreen ? null : portalEl}
          onPlay={trackMediaPlay}
          onProgress={trackMediaProgress}
          onFullscreenChange={setIsFullscreen}
        />
      )}
    </StyledContainer>
  );
};

MediaTitle.propTypes = {
  routeProps: PropTypes.object,
  type: PropTypes.oneOf(['video', 'audio']),
  source: PropTypes.string,
  versions: PropTypes.arrayOf(PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
    url: PropTypes.string,
  })),
  metadata: PropTypes.shape({
    sourceId: PropTypes.string,
    sourceUrl: PropTypes.string,
  }),
};

export default MediaTitle;
